import * as icons from 'react-bootstrap-icons';
import IIconProps from "./IIconProps";

export const Icon = ({ iconName, ...props }: IIconProps) => {
    const BootstrapIcon = icons[iconName];
    const cssStartMargin = props.startMargin ? `ms-${props.startMargin}` : "",
        cssEndMargin = props.endMargin ? `me-${props.endMargin}` : "";

    return <BootstrapIcon name={iconName} className={`${cssStartMargin} ${cssEndMargin}`} />;
}